import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsArrowClockwise, BsCheck, BsClock } from 'react-icons/bs';

import Card from 'v3/components/Card';
import { Button, Text } from 'v3/components';

import {
  LINEAR_STEPS,
  NOT_INFORMED,
  STATUS,
  STATUS_NAMES,
  formatDateOnly,
  getStatusName,
} from '../shared/status';

const statusVisualMap = {
  completed: {
    Icon: BsCheck,
    iconSize: 22,
    background: '#d1f4dd',
    border: '1px solid #48b879',
    color: '#2f9b61',
  },
  'in-progress': {
    Icon: BsArrowClockwise,
    iconSize: 16,
    background: '#eef4ff',
    border: '1px solid #4c77f2',
    color: '#4c77f2',
  },
  pending: {
    Icon: BsClock,
    iconSize: 16,
    background: '#f3f4f6',
    border: '1px solid #d1d5db',
    color: '#9ca3af',
  },
};

function StatusBadgeIcon({ Icon, iconSize, background, border, color }) {
  return (
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        background,
        border,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color,
      }}
    >
      <Icon size={iconSize} />
    </div>
  );
}

function StepStatusItem({ title, status }) {
  const visual = statusVisualMap[status] || statusVisualMap.pending;

  return (
    <Col className="mb-3" style={{ textAlign: 'center', minWidth: 140 }}>
      <div style={{ marginBottom: '0.5rem' }}>
        <StatusBadgeIcon {...visual} />
      </div>
      <Text weight="600" fontSize="0.95rem" style={{ display: 'block' }}>
        {title}
      </Text>
    </Col>
  );
}

function getStepStatus(index, currentIndex) {
  if (currentIndex < 0) return 'pending';
  if (index < currentIndex) return 'completed';
  if (index === currentIndex) return 'in-progress';
  return 'pending';
}

export default function StatusPanel({ request, onOpenAudit, headerActions = null }) {
  const slug = request?.status?.slug;
  const currentIndex = LINEAR_STEPS.indexOf(slug);
  const isRejected = slug === STATUS.REJECTED;

  return (
    <Card
      header={
        <Text color="dark" type="header">
          Situação do cadastro
        </Text>
      }
      HeaderRightComponent={
        <div className="d-flex align-items-center flex-wrap" style={{ gap: '0.5rem' }}>
          {headerActions}
          {onOpenAudit && (
            <Button variant="secondary" size="sm" onClick={onOpenAudit}>
              <Text color="dark" weight={500} type="regular">
                Auditoria
              </Text>
            </Button>
          )}
        </div>
      }
    >
      <div style={{ marginBottom: '1.25rem' }} />
      <Row>
        {LINEAR_STEPS.map((stepSlug, index) => (
          <StepStatusItem
            key={stepSlug}
            title={STATUS_NAMES[stepSlug]}
            status={getStepStatus(index, currentIndex)}
          />
        ))}
      </Row>

      <div
        style={{
          background: '#e8f1ff',
          borderRadius: 8,
          padding: '0.75rem 1rem',
          marginTop: '0.5rem',
        }}
      >
        <Text color="#2f5fdb" weight="600" data-testid="request-status">
          Status atual: {getStatusName(request?.status)}
        </Text>
      </div>

      {isRejected && (
        <div
          data-testid="rejection-notice"
          style={{
            background: '#fdecea',
            border: '1px solid #f5c2c0',
            borderRadius: 8,
            padding: '0.75rem 1rem',
            marginTop: '0.75rem',
          }}
        >
          <Text color="#b42318" weight="600" style={{ display: 'block' }}>
            Cadastro Reprovado
          </Text>
          <Text color="#b42318" style={{ display: 'block', whiteSpace: 'pre-wrap' }}>
            Motivo da reprovação: {request?.rejectionReason || NOT_INFORMED}
          </Text>
        </div>
      )}

      <div style={{ marginTop: '0.75rem' }}>
        <Text type="label" color="dark">
          Início emissão contra CT-e:{' '}
        </Text>
        <Text type="regular" color="gray" data-testid="emission-start-date">
          {formatDateOnly(request?.emissionStartDate)}
        </Text>
      </div>
    </Card>
  );
}
